export class TransactionSendResource {
        idCliente: number;
        idFormaPagamento: number;
        idProduto: number;
        qtdParcelas: number;
        affiliateId: number;
        dueDate: string;
        description: string;
}